import React from "react"

import { styled } from "@mui/material"

import { useCustomerInfo } from "@cirrus/common/CustomerInfo"
import { useTranslations } from "@cirrus/core/i18n/provider"

import { useNews } from "./context"

export const NewsBlock = () => {
  const { i18n } = useTranslations()
  const newsContext = useNews()
  const customerInfoContext = useCustomerInfo()

  if (!newsContext.data || !customerInfoContext.data) return null

  const { text } = newsContext.data

  return <Container className="sfl-info-panel">
    <ScrollArea>
      <Text dangerouslySetInnerHTML={{ __html: text }} />
    </ScrollArea>
  </Container>
}

const Container = styled("aside")(({ theme }) => ({
  gridColumn: 1,
  gridRow: "1/-1",  /* span rows 1-2 so height doesn't push LanguageSelector down */
  justifySelf: "end",
  borderRadius: "1.6rem",
  background: "#FAFAFA",
  width: "70%",
  maxWidth: "70%",
  height: "100%",
  maxHeight: "48.9rem",
  padding: "1.6rem 2rem",
  fontSize: "1.4rem",
  marginRight: "2rem",
  overflow: "hidden",

  [theme.breakpoints.down("md")]: {
    gridColumn: 1,
    order: 2,
    justifySelf: "stretch",
    width: "100%",
    maxWidth: "54.4rem",
    marginRight: "0",
    marginTop: "2rem",
  }
}))

const ScrollArea = styled("div")({
  overflow: "auto",
  height: "100%",
  paddingRight: "4px",
})

const Text = styled("span")({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0,
  color: "#1A1A1A",
  maxHeight: "calc(2rem * 13)",
  overflow: "auto"
})
